module.exports = __webpack_public_path__ + "static/img/e984039639f04d71(1).3f21acce.png";